import React from 'react';
import { Form as FormAntd } from 'antd';

const Form = ({ children, ...rest }) => {
  return (
    <FormAntd layout="vertical" requiredMark="optional" {...rest}>
      {children}
    </FormAntd>
  );
};

export default Form;
